import React from 'react';
import { cn } from '../../../utils/cn';
import Section from '../Section';
import { COMPANY } from '../content';
import styles from './CompanyIntro.module.css';

const LOGO_WHITE_SRC = `${process.env.PUBLIC_URL}/assets/images/raid2026/logo_jtcc_horizontal_white.svg`;

// 「急成長企業で」「働きたいあなたへ」で改行できるよう最初の「で」で分割する。
function renderCatch(text) {
  const idx = text.indexOf('で');
  if (idx === -1) {
    return text;
  }
  return (
    <>
      {text.slice(0, idx + 1)}
      <wbr />
      <span className={styles.catchBreak} />
      {text.slice(idx + 1)}
    </>
  );
}

function renderDescriptionLine(line) {
  const phrase = '急成長スタートアップ';
  const idx = line.indexOf(phrase);
  if (idx === -1) {
    return line;
  }

  return (
    <>
      {line.slice(0, idx)}
      <span className={styles.noBreakPhrase}>{phrase}</span>
      {line.slice(idx + phrase.length)}
    </>
  );
}

export default function CompanyIntro() {
  return (
    <Section id="company">
      <div className={styles.wrap}>
        <h2 className={styles.catch}>{renderCatch(COMPANY.catch)}</h2>
        <span className={styles.rule} aria-hidden="true" />
        <img
          src={LOGO_WHITE_SRC}
          alt="日本トレカセンター"
          className={styles.logo}
          loading="lazy"
          width="193"
          height="28"
        />
        <p className={styles.description}>
          {COMPANY.description.map(line => (
            <span key={line} className={styles.descriptionLine}>
              {renderDescriptionLine(line)}
            </span>
          ))}
        </p>
        <ul className={styles.metrics}>
          {COMPANY.metrics.map(metric => (
            <li key={metric.label} className={styles.metric}>
              <span className={styles.metricLabel}>{metric.label}</span>
              <span className={styles.metricValue}>
                {metric.value.map((part, index) => (
                  <span
                    key={`${metric.label}-${index}`}
                    className={cn(
                      part.accent && styles.metricAccent,
                      part.sub && styles.metricSub
                    )}
                  >
                    {part.t}
                  </span>
                ))}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
